module.exports = __webpack_public_path__ + "gcicLogo.png?77a8a5e324c1a14c6fe8389b1ded652d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gcicLogo.png
// module id = 64
// module chunks = 0